import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ControlContainer, NgForm, NgModelGroup} from '@angular/forms';
import * as _ from 'lodash';
import {ComboCargo} from "../../../core/combo-cargo";
import {CargosService} from "../../../services/cargos/cargos.service";


@Component({
    selector: 'combo-cargo',
    templateUrl: './combo-cargo.component.html',
    styleUrls: ['./combo-cargo.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboCargoComponent implements OnInit {

    @ViewChild('comboCargo', {static: false}) comboCargo;

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;
    @Input() label = 'Cargo';

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private cargoService: CargosService) {
    }

    ngOnInit(): void {
        this.data = Date.now();

        setTimeout(() => {
            this.cargoService.getAllCombo().subscribe((cargos: ComboCargo[]) => {
                this.dados = cargos;
                this.preencherCombo();
            });
        }, 0)

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
            this.preencherCombo();
        }
    }

    private preencherCombo() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherCombo();
    }


}
